<template>
    <div class="threads" :style="`height: ${height}`">
        <b-modal no-close-on-backdrop title="Search text in Thread" class="modal-success" v-model="searchThreadDlg" ok-variant="success" :ok-only="true" ok-title="Close" size="xl" @ok="searchThreadDlg=false">
            <b-container fluid>
                <!-- il testo non è tantissimo e dovrebbe bastare il filtro sulle colonne -->
                <b-row v-if="false">
                    <b-col>
                        <b-form-group id="input-group-1" label="Text to search" label-for="input-search">
                            <b-form-input id="input-search" v-model="searchText" type="text" placeholder="text to search" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <AgGridVue :style="`height: 280px;width: 100%`" 
                                class="ag-theme-alpine" 
                                :columnDefs="columnDefs" 
                                :rowData="foundText"
                                :defaultColDef="defaultColDef" 
                                :suppressColumnVirtualisation="false" >
                        </AgGridVue>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
        <b-modal no-close-on-backdrop :title="editThreadDlg ? 'Edit Thread' : 'Add Thread'" class="modal-success" v-model="addThreadDlg" ok-variant="success" :ok-only="false" ok-title="Save" size="lg"
            @ok="onSubmitThread">
            <b-container fluid>
                <b-card :title="editThreadDlg ? 'Edit thread' : 'Add new thread'">
                    <b-form @submit.prevent="onSubmitThread">
                        <b-container fluid>
                            <b-row>
                                <b-col>
                                    <b-form-group id="input-group-1" label="Thread title" label-for="input-title">
                                        <b-form-input id="input-title" v-model="formThread.title" type="text" placeholder="Insert thread title" required />
                                    </b-form-group>
                                    <b-form-group id="input-group-2" label="People involved in" label-for="input-people">
                                        <multi-select :options="peoples" :selected-options="formThread.people" @select="onMSelect"></multi-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-form>
                </b-card>
            </b-container>
            <template #modal-footer="{ ok, cancel }">
                <!-- Button with custom close trigger value -->
                <b-button size="sm" variant="danger" @click="deletethread()" v-if="editThreadDlg">
                    DELETE THREAD
                </b-button>
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="sm" variant="danger" @click="cancel()">
                    Cancel
                </b-button>
                <b-button size="sm" variant="success" @click="ok()">
                    OK
                </b-button>
            </template>
        </b-modal>
        <b-card title="Communication">
            <b-container fluid>
                <b-row>
                    <b-col cols="2" class="threadslist">
                        <b-card title="Threads">
                            <b-card-text>
                                <ul>
                                    <li v-for="thread in threads" :key="thread.id" :class="thread.id == currThread.id ? 'selected' : ''">
                                        <a href="#" @click="selThread(thread)">{{ thread.name }}</a>
                                    </li>
                                </ul>
                            </b-card-text>
                        </b-card>
                        <b-button variant="danger" block @click="addThreadDlg = true">+</b-button>
                    </b-col>
                    <b-col cols="10">
                        <b-card :title="currThread.name">
                            <Communication :m="machine" :thread="currThread" :threadmode="true" />
                        </b-card>
                        <b-button block @click="onEditThread()" class=right>&#x270E;</b-button>
                        <b-button block @click="onSearchThread()" class=left>&#x1F50E;&#xFE0E;</b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-card>
    </div>
</template>
<script>
import { MultiSelect } from "vue-search-select";
import 'vue-search-select/dist/VueSearchSelect.css'
import Communication from "@/components/Communication.vue";
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);

export default {
    name: "Threads",
    components: {
        MultiSelect,
        Communication,
        AgGridVue,
    },
    data: function () {
        return {
            addThreadDlg: false,
            editThreadDlg: false,
            searchThreadDlg: false,
            formThread: {
                title: "",
                people: []
            },
            peoples: [],
            threads: [],
            currThread: {},
            searchText: null,
            foundText: [],
            defaultColDef: {
                sortable: true,
                filter: true,
				resizable: true, 
            },
            columnDefs: [
                { hide: true, field: "id" },
                { headerName: "Thread" , field: "thread",  width: '100px', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, cellClass: 'ag-left-aligned-cell', },
                { headerName: "Message", field: "message", width: '300px', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, cellClass: 'ag-left-aligned-cell', },
                { headerName: "Date", field: "ts", width: '190px', filter: 'agDateColumnFilter',valueFormatter: this.dateFormatter,filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "From Marsilli", field: "dam", width: '230px', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] },cellClass: 'ag-left-aligned-cell', },
                { headerName: "From Client"  , field: "dac", width: '230px', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] },cellClass: 'ag-left-aligned-cell', },
            ],
        }
    },
    props: {
        height: { type: String, default: "calc(100vh - 750px)" }
    },
    async mounted() {
        await this.getPeoples()
        this.threads = await API.piGetThreads(this.machine.codice,this.section)
        if (this.threads.length > 0) {
            this.selThread(this.threads[0]);
        }
    },
    watch: {
        searchText: async function (val) {
            console.log("searchText", val)
            let tmp
            if (val.length > 0) {
                tmp = await API.piSearchThreads(this.machine.codice, this.section, val)
            } else {
                tmp = await API.piSearchThreads(this.machine.codice, this.section, "")
            }
            console.log("tmp", tmp)
            this.foundText = tmp.map(t => {
                return { id: t.id, thread: t.tname, message: t.message, ts: new Date(t.ts), dam: t.dam ? this.userName(t) : '', dac: !t.dam ? this.userName(t) : '' }
            });
        }
    },
    computed: {
        section(){
            return this.$store.getters.section
        },
        machine(){
            return this.$store.getters.machine
        },
    },
    methods: {
        dateFormatter(params) {
            return params.value.toLocaleString();
        },
        selThread(thread) {
            this.currThread = thread;
            this.currThread.users = this.filterUsers(this.currThread.users);
            console.log("selThread", this.currThread)
        },
        filterUsers(users) { // se elimino degli elementi dal team potrei avere degli users non più validi !
            if(!users) return "";
            return users.split(',').filter(u => this.peoples.find(p => p.value == u)).join(',');
        },
        async getPeoples(){
            let peoples = await API.getTeams(this.machine.codice, this.section)
            this.peoples = peoples.map(p => {
                let value = p.id;
                let text
                if (p.name && p.surname) {
                    text = `${p.name} ${p.surname}`;
                } else if (p.email) {
                    text = p.email;
                } else {
                    text = p.login;
                }
                text += ` (${p.text})`;
                text += p.marsilli ? ` - (Marsilli)` : ` - (Customer)`;
                return { value, text }
            });
            console.log("peoples", this.peoples)
        },
        async deletethread() {
            console.log("deletethread")
            await API.piDeleteThread(this.currThread.id, this.section)
            this.threads = await API.piGetThreads(this.machine.codice, this.section)
            if (this.threads.length > 0) {
                this.selThread(this.threads[0]);
            } else {
                this.currThread = {};
            }
            this.editThreadDlg = this.addThreadDlg = false;
        },
        async onSearchThread(){
            this.searchThreadDlg = true;
            this.searchText = "";
        },
        async onEditThread() {
            console.log("onEditThread",this.currThread)
            await this.getPeoples()
            this.formThread.title = this.currThread.name;
            this.formThread.people = this.currThread.users ? this.currThread.users.split(',').map(u => ({ value: parseInt(u), text: this.peoples.find(pp => pp.value == u).text })) : [];
            this.editThreadDlg = this.addThreadDlg = true;
        },
        async onSubmitThread() {
            console.log("onSubmitThread")
            if (this.editThreadDlg) {
                await API.piEditThread(this.currThread.id, this.formThread.title, this.formThread.people.map(p => p.value), this.section)
            } else {
                await API.piAddThread(this.machine.codice, this.formThread.title, this.formThread.people.map(p => p.value), this.section)
            }
            this.threads = await API.piGetThreads(this.machine.codice, this.section)
            this.currThread = this.threads.find(t => t.name == this.formThread.title);
            this.currThread.users = this.filterUsers(this.currThread.users);
            this.formThread = { title: "", people: [] }
        },
        onMSelect(items) {
            console.log("ITEMS", items);
            this.formThread.people = items;
        },
    }
}

</script>
<style scoped>
div.threadslist h4 {
    text-align: left;
    ;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    text-align: left;
}

ul li a {
    text-decoration: none;
    color: black;
}

ul li.selected a {
    font-weight: bold
}

div.threads button {
    background-color: #9a240d !important;
    border-color: #9a240d !important;
    margin-bottom: 10px;
}

div.threads button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5) !important;
}

div.threads button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5) !important;
}

div.card button.right {
    width: 24px;
    height: 24px;
    padding: 0px;
    /* padding-bottom: 0px; */
    position: absolute;
    top: 25px;
    right: 20px;
}
div.card button.left {
    width: 24px;
    height: 24px;
    padding: 0px;
    /* padding-bottom: 0px; */
    position: absolute;
    top: 25px;
    left: 20px;
}
</style>
